import { createSelector } from 'reselect';
const presentationsSlidesSelector = presentation => presentation.slides;
export default createSelector(presentationsSlidesSelector, slides => {
  if (!slides) return [];
  return slides.map(({
    largeUrl
  }) => largeUrl);
});